(() => {
    function handleAnchorAction() {
        const hash = window.location.hash
        if (!hash) return;

        const el = document.getElementById(hash.substring(1))
        if (el) {
            const acpanel = el.closest(".acpanel")
            if (acpanel) {
                btn = acpanel.querySelector(".panel-heading")
                btn.setAttribute("aria-expanded", "true")
                el.classList.add("show")
            }
        }
    }

    // Run when the page initially finishes loading
    window.addEventListener('load', handleAnchorAction);
    console.log("anchor handler added")
})();